module.exports = __webpack_public_path__ + "img/0.acacd250.png";